import ChatMemberList from "../ChatMemberList/ChatMemberList";
import styles from "./ChatDetailsPage.styles.scss";
import ListItem from "../list-item";
import {Body} from "../typography";
import Margin from "../Margin/Margin";
import LinkButton from "../LinkButton/LinkButton";
import ChatSettings from "../ChatSettings/ChatSettings";
import SearchBox from "../SearchBox/SearchBox";

const ChatDetailsPage = ({
                           channelName,
                           members,
                           restrictedUntil,
                           messageDisplayPeriodDays,
                           onBack,
                           onChangeRestrictedUntil,
                           onChangeMessageDisplayPeriodDays,
                           onRequestMute,
                           loading,
                           onChangeQuery,
                           query = '',
}) => {
  return <div className={styles.container}>
    <Margin left={16}>
      <LinkButton leftIconName='arrow_backward' text='Voltar' onClick={onBack}/>
    </Margin>
    <Margin top={16}/>
    {
      channelName && <ListItem className={styles.listItem}
              title={<Margin horizontal={16}><Body size="body2" className={styles.listItemTitle}>Identificador do canal</Body></Margin>}
              subtitle={<Margin top={8} horizontal={16}><Body size="body2" loading={loading} wireframeWidth={175}>{channelName}</Body></Margin>}/>
    }
    <Margin top={8}/>
    <ListItem className={styles.listItem}
              title={<Margin horizontal={16}><Body size="body2" className={styles.listItemTitle}>Configurações do canal</Body></Margin>}
              subtitle={
                <Margin top={8}><ChatSettings
                  restrictedUntil={restrictedUntil}
                  messageDisplayPeriodDays={messageDisplayPeriodDays}
                  loading={loading}
                  onRestrict={onChangeRestrictedUntil}
                onChangeMessageDisplayPeriodDays={onChangeMessageDisplayPeriodDays}/></Margin>
              }/>
    <Margin top={8}/>
    <div className={styles.listItem}>
      <div className={styles.listItemHeader}>
        <Body size="body2" className={styles.listItemTitle}>Lista de membros</Body>
      </div>
      <Margin top={8}/>
      <SearchBox query={query} onChangeQuery={onChangeQuery} />
      <Margin top={8}/>
      <ChatMemberList members={members} loading={loading} onRequestMute={onRequestMute}/>
    </div>
  </div>;
};

export default ChatDetailsPage;



// WEBPACK FOOTER //
// ./components/ChatDetailsPage/ChatDetailsPage.js